var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4971 12.8302C19.4299 13.6389 18.0996 14.1187 16.6573 14.1187C13.1425 14.1187 10.2932 11.2693 10.2932 7.7545C10.2932 6.71542 10.5422 5.7345 10.9838 4.86816C7.89943 5.77837 5.64844 8.63194 5.64844 12.0112C5.64844 16.1239 8.9824 19.4579 13.0951 19.4579C16.9309 19.4579 20.0894 16.5575 20.4971 12.8302Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4971 12.8302L21.2924 12.9172L20.014 12.1926L20.4971 12.8302ZM10.9838 4.86816L11.6965 5.23149L10.7574 4.10088L10.9838 4.86816ZM20.014 12.1926C19.0809 12.8995 17.9192 13.3187 16.6573 13.3187V14.9187C18.28 14.9187 19.7788 14.3782 20.9803 13.4678L20.014 12.1926ZM16.6573 13.3187C13.5843 13.3187 11.0932 10.8275 11.0932 7.7545H9.49316C9.49316 11.7112 12.7007 14.9187 16.6573 14.9187V13.3187ZM11.0932 7.7545C11.0932 6.84461 11.3109 5.9879 11.6965 5.23149L10.2711 4.50484C9.77341 5.4811 9.49316 6.58623 9.49316 7.7545H11.0932ZM6.44844 12.0112C6.44844 8.99616 8.45667 6.44804 11.2102 5.63545L10.7574 4.10088C7.34218 5.10871 4.84844 8.26771 4.84844 12.0112H6.44844ZM13.0951 18.6579C9.42423 18.6579 6.44844 15.6821 6.44844 12.0112H4.84844C4.84844 16.5657 8.54057 20.2579 13.0951 20.2579V18.6579ZM19.7019 12.7432C19.338 16.0693 16.5183 18.6579 13.0951 18.6579V20.2579C17.3436 20.2579 20.8408 17.0458 21.2924 12.9172L19.7019 12.7432Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.df37882d7639e4b833fb1626a0405641.svg";
export { ForwardRef as ReactComponent };